// @flow
import React from 'react';
import {
    createFragmentContainer,
    graphql,
} from 'react-relay';

import {
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

import { withRouter } from 'react-router-dom';

const personTypes = {
    host: 'Ведущий',
    author: 'Автор',
    person: 'Персоналия',
};


export class PeopleListItem extends React.Component {
    render() {
        return (
            <TableRow onClick={() => this.props.history.push(`/person/${this.props.person.id}`)}>
                <TableRowColumn>{personTypes[this.props.person.personType]}</TableRowColumn>
                <TableRowColumn colSpan="5">{this.props.person.firstName} {this.props.person.lastName}</TableRowColumn>
            </TableRow>)
    }
}

export default withRouter(createFragmentContainer(
    PeopleListItem,
    graphql`
        fragment PeopleListItem_person on Person {
            id,
            firstName,
            lastName,
            personType,
        }
    `
))



// WEBPACK FOOTER //
// src/components/PeopleListItem.js